import { render, staticRenderFns } from "./PurE_Details2.vue?vue&type=template&id=55ff3163"
import script from "./PurE_Details2.vue?vue&type=script&lang=js"
export * from "./PurE_Details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports